/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useContext, useMemo } from 'react';
import moment from 'moment';
import './StoreTitle.scss';
import { Rating, Avatar, Chip } from '@mui/material';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import FaceIcon from '@mui/icons-material/Face';
import variables from '../../global/assets/_variables.scss';
import { isMobile, isDesktop, isIpad } from '../../global/ScreenSizeHelper';
import { CLOCK_PNG, FIRE_COMPLEMENTARY } from '../../global/assets/Icons';
import { OnTheMenuDataContext } from '../../context-api/OnTheMenuDataProvider';
import { LoginDataContext } from '../../context-api/LoginDataProvider';
import { MealOfferingCalculation } from './../../global/calculations';
import DeliveryTimeSlotPicker from '../deliveryTimeSlotPicker/DeliveryTimeSlotPicker';
import { canPlaceOrder } from '../../global/generateDeliveryTimeSlots';
import Loader from '../Loader/Loader';
import fallBackImage from '../../global/assets/png/clock-blue.png';
import imageUrlTransformation from '../../global/imageUrlTransformation';
import DiscountIcon from '@mui/icons-material/Discount';
import { distanceAndETA } from '../../utils/distanceMileCalculate';
import { localStorageKeys } from '../../global/constants';
import { getUrlParams } from '../../global/getUrl';

function Storetitle(props) {
  const { mealType = 'meal' } = props;
  const { sortedKitchenData, activeButton, setActiveButton, productsData } =
    useContext(OnTheMenuDataContext);
  const { storename: urlStoreName } = getUrlParams();
  const UrlAndProductKitchenAreSame =
    productsData?.data?.data?.[urlStoreName]?.kitchenName === urlStoreName;

  const { ZIPCODE_GEO_COORDINATES } = localStorageKeys;

  const {
    operation_start_time,
    operation_end_time,
    display_name,
    delivery_type_available,
    address,
    deliveryPayAsYouGo_fee,
    deliverySubscription_fee,
    delivery_agreement_fees,
    cuisine,
    meal_offering,
    opening_status,
    status,
    freeSubscriptionDelivery,
    freeSubscriptionDelivery_TimeGap,
  } = sortedKitchenData;
  const { isLoggedIn, customerInfoData } = useContext(LoginDataContext);
  const { loading, data, success, errorMessage } = customerInfoData;
  const custInfoData = data?.data || [];
  const custMealPlan = custInfoData?.meal_Package?.meal_plan;

  const CheckAgreementlength =
    Array.isArray(delivery_agreement_fees) && delivery_agreement_fees.length > 0;
  const time = moment();
  const currentTime = moment(time, 'HH:mm:ss').format('HH:mm:ss');
  const currentDate = moment().format('MM/DD/YYYY');
  const startTime = moment(operation_start_time, 'HH:mm:ss a').format('HH:mm:ss');
  const endTime = moment(operation_end_time, 'HH:mm:ss a').format('HH:mm:ss');
  // const isOpen = currentTime >= startTime && currentTime <= endTime;  // Kuldeep check pls
  const isOpen = canPlaceOrder(moment(), operation_start_time, operation_end_time);

  const activeColor = activeButton === 'delivery';
  const [isOnPromo, setIsOnPromo] = useState(true);
  const [freeColor, setFreeColor] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [isValueMeal, setIsValueMeal] = useState(true);
  const storeStatus = isOpen ? 'OPEN' : 'Closed';
  const storeTiming = isOpen
    ? `- Closes at ${operation_end_time}`
    : `- Open at ${operation_start_time}`;
  const fontColor = isOpen ? variables.backgroundGreen : variables.backGroundErrorRed;

  const MealOffering_MainDish = MealOfferingCalculation({
    CustomerMealPackage: custMealPlan,
    KitchenMealOffering: meal_offering?.main_dish,
  });

  const MealOfferin_Starter = MealOfferingCalculation({
    CustomerMealPackage: custMealPlan,
    KitchenMealOffering: meal_offering?.starter,
  });

  const MealOfferin_Side = MealOfferingCalculation({
    CustomerMealPackage: custMealPlan,
    KitchenMealOffering: meal_offering?.side,
  });

  const MealOfferin_PowerSide = MealOfferingCalculation({
    CustomerMealPackage: custMealPlan,
    KitchenMealOffering: meal_offering?.power_side,
  });

  const MealOfferin_DrinkDessertTreat = MealOfferingCalculation({
    CustomerMealPackage: custMealPlan,
    KitchenMealOffering: meal_offering?.drink_dessert_treat,
  });

  const MealOfferin_Complementary = MealOfferingCalculation({
    CustomerMealPackage: custMealPlan,
    KitchenMealOffering: meal_offering?.complementary,
  });

  // console.log('----Tab type', mealType)
  // console.log('------deliverySubscription_fee', deliverySubscription_fee)
  // console.log('----sortedKitchenData', sortedKitchenData)
  // console.log('----Check free and time gap ', { freeSubscriptionDelivery, freeSubscriptionDelivery_TimeGap })
  // console.log('----address', address)

  const verbageFree =
    freeSubscriptionDelivery_TimeGap === 1440
      ? 'FREE NextDay delivery'
      : `FREE Delivery after ${freeSubscriptionDelivery_TimeGap / 60} hour`;

  let minimumAmountSpendOne = null;
  let percentageToPayOne = null;
  let minimumAmountSpendTwo = null;
  let percentageToPayTwo = null;
  let minimumAmountSpendThree = null;
  let percentageToPayThree = null;

  const PercentageCalculation = (percentage) => {
    const calculatedAmount = (deliveryPayAsYouGo_fee * (100 - percentage)) / 100;
    if (calculatedAmount === 0) {
      return 'Free';
    }

    return `$${calculatedAmount.toFixed(2)}`;
  };

  if (delivery_agreement_fees) {
    minimumAmountSpendOne = delivery_agreement_fees[0]?.minimumAmountSpend;
    percentageToPayOne = PercentageCalculation(
      delivery_agreement_fees[0]?.percentageToPay_byKitchen
    );
    minimumAmountSpendTwo = delivery_agreement_fees[1]?.minimumAmountSpend;
    percentageToPayTwo = PercentageCalculation(
      delivery_agreement_fees[1]?.percentageToPay_byKitchen
    );
    minimumAmountSpendThree = delivery_agreement_fees[2]?.minimumAmountSpend;
    percentageToPayThree = PercentageCalculation(
      delivery_agreement_fees[2]?.percentageToPay_byKitchen
    );
  }

  const onImageLoad = () => {
    setImageLoaded(true);
  };

  const onImageError = () => {
    setImageError(true);
    setImageLoaded(true);
  };

  const getGeoCoordinateLocal = () => [localStorage.getItem(ZIPCODE_GEO_COORDINATES)];

  const CustomerCoordinate = getGeoCoordinateLocal()[0]?.split(',')?.map(Number)?.reverse();
  const KitchenCoordinate =
    productsData?.data?.data?.[urlStoreName]?.Geolocation?.coordinates?.reverse();

  // roadFactor   = is depend on road condition if its 1.35 time will increase and if its 1.1 it will reduce

  const DistanceMemo = useMemo(() => {
    if (
      UrlAndProductKitchenAreSame &&
      CustomerCoordinate?.length > 0 &&
      KitchenCoordinate?.length > 0
    ) {
      return distanceAndETA(CustomerCoordinate, KitchenCoordinate, {
        roadFactor: 1.0,
        avgSpeedMph: 22,
        trafficMultiplier: 1.25,
        fixedDelayMin: 2,
      });
    }
  }, [UrlAndProductKitchenAreSame, CustomerCoordinate, KitchenCoordinate]);

  if (isMobile) {
    return (
      <div className='store-title-mobile-container'>
        <div className='store-logo-desc-operation-mobile'>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              border: '1px  solid #F1F1F1',
              height: '30px',
              width: '30px',
              borderRadius: '5px',
              overflow: 'hidden',
              marginLeft: '46%',
              objectFit: 'cover',
            }}
          >
            <img
              width={imageLoaded ? '100%' : 0}
              src={
                imageError
                  ? fallBackImage
                  : imageUrlTransformation({
                      imageUrl: sortedKitchenData?.display_image,
                      fillType: 'fill',
                      width: 100,
                    })
              }
              onLoad={() => onImageLoad()}
              onError={() => onImageError()}
              onClick={() => {
                // console.log("image clicked pdp desktop");
              }}
            />

            {!imageLoaded && <Loader color='black' width='20px' height='20px' />}
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              fontSize: '18px',
              fontFamily: 'Inter Bold', // Inter Medium Inter Bold  Inter Light Inter ExtraLight Inter ExtraBold
              fontWeight: 500,
              letterSpacing: '0.3px',
              // textAlign: 'start'
            }}
          >
            {display_name}
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom: '3px',
              marginTop: '10px',
            }}
          >
            <FastfoodIcon sx={{ color: '#181436', fontSize: '12px', marginRight: '5px' }} />
            <div
              style={{
                fontSize: '14px',
                fontFamily: 'Inter Bold', // Inter Medium Inter Bold  Inter Light Inter ExtraLight
                letterSpacing: '0.5px',
              }}
            >
              Combo bundle
            </div>

            <Chip
              label='Extra Saving'
              size='small'
              sx={{
                border: '1px solid #86c49a',
                background: '#dff5cf',
                color: '#06763f',
                height: '17px',
                fontSize: '10px',
                fontFamily: 'Inter Light',
                marginLeft: '10px',
              }}
            />
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexWrap: 'wrap',
            }}
          >
            {meal_offering?.main_dish !== 0 && meal_offering?.main_dish !== undefined && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  fontSize: '12px',
                  fontFamily: 'Inter Regular',
                  letterSpacing: '0.5px',
                  color: 'black',
                }}
              >
                {MealOffering_MainDish} {MealOffering_MainDish >= 2 ? 'Main dishes' : 'Main dish'} +
                &nbsp;
              </div>
            )}

            {meal_offering?.starter !== 0 && meal_offering?.starter !== undefined && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  fontSize: '12px',
                  fontFamily: 'Inter Regular',
                  letterSpacing: '0.5px',
                  color: 'black',
                }}
              >
                {MealOfferin_Starter} {MealOfferin_Starter >= 2 ? 'Starters' : 'Starter'} + &nbsp;
              </div>
            )}

            {meal_offering?.side !== 0 && meal_offering?.side !== undefined && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  fontSize: '12px',
                  fontFamily: 'Inter Regular',
                  letterSpacing: '0.5px',
                  color: 'black',
                }}
              >
                {MealOfferin_Side} {MealOfferin_Side >= 2 ? 'Sides' : 'Side'} + &nbsp;
              </div>
            )}

            {meal_offering?.power_side !== 0 && meal_offering?.power_side !== undefined && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  fontSize: '12px',
                  fontFamily: 'Inter Regular',
                  letterSpacing: '0.5px',
                  color: 'black',
                }}
              >
                {MealOfferin_PowerSide} {MealOfferin_PowerSide >= 2 ? 'Jumbo Sides' : 'Jumbo Side'}{' '}
                + &nbsp;
              </div>
            )}

            {meal_offering?.drink_dessert_treat !== 0 &&
              meal_offering?.drink_dessert_treat !== undefined && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    fontSize: '12px',
                    fontFamily: 'Inter Regular',
                    letterSpacing: '0.5px',
                    color: 'black',
                  }}
                >
                  {MealOfferin_DrinkDessertTreat}{' '}
                  {MealOfferin_DrinkDessertTreat >= 2
                    ? 'Drinks or Dessert treats'
                    : 'Drink or Dessert treat'}{' '}
                  + &nbsp;
                </div>
              )}

            {meal_offering?.complementary !== 0 && meal_offering?.complementary !== undefined && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  fontSize: '12px',
                  fontFamily: 'Inter Regular',
                  letterSpacing: '0.5px',
                  color: 'black',
                }}
              >
                {' '}
                {MealOfferin_Complementary}&nbsp;
                {MealOfferin_Complementary >= 2 ? 'Complementaries' : 'Complementary'} &nbsp;
                <img style={{ width: '18px' }} src={FIRE_COMPLEMENTARY} alt=''></img>
              </div>
            )}
          </div>

          <div className='store-timing-mobile'>
            <div className={isOpen ? 'store-status-open-text' : 'store-status-closed-text'}>
              {storeStatus}{' '}
            </div>
            <div className='store-timing-text-mobile'> {storeTiming}</div>
            {/* <div className='promo-code-mobile' onClick={() => { console.log('-----Promo clicked') }}> &nbsp; &nbsp;| &nbsp; Promo codes </div> */}
            <div
              style={{
                fontSize: '14px',
                fontFamily: 'Inter Regular',
                color: 'gray',
                marginBottom: '3.5px',
              }}
            >
              {' '}
              &nbsp; | {DistanceMemo?.roadMiles || 0} mi{' '}
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isIpad || isDesktop) {
    return (
      <div className='store-title-ipad-container'>
        <div className='storename-storeopen-storetiming-ipad'>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              border: '1px  solid #F1F1F1',
              height: '30px',
              width: '30px',
              borderRadius: '5px',
              overflow: 'hidden',
              objectFit: 'cover',
              marginRight: '5px',
            }}
          >
            <img
              width={imageLoaded ? '100%' : 0}
              src={
                imageError
                  ? fallBackImage
                  : imageUrlTransformation({
                      imageUrl: sortedKitchenData?.display_image,
                      fillType: 'fill',
                      width: 100,
                    })
              }
              onLoad={() => onImageLoad()}
              onError={() => onImageError()}
              onClick={() => {
                // console.log("image clicked pdp desktop");
              }}
            />

            {!imageLoaded && <Loader color='black' width='20px' height='20px' />}
          </div>
          <div className='kitchenname-text-ipad'>{display_name} </div>
          <div className='clock-image-icon-style-ipad'>
            &nbsp; | &nbsp; <img alt='' src={CLOCK_PNG} height={12} width={12}></img>
          </div>
          <div className={isOpen ? 'store-status-open-text' : 'store-status-closed-text'}>
            {storeStatus}{' '}
          </div>
          <div className='store-timing-text-ipad'> {storeTiming}</div>

          <div
            style={{
              fontSize: '14px',
              fontFamily: 'Inter Regular',
              // color: 'gray',
              marginBottom: '3.5px',
            }}
          >
            {' '}
            &nbsp; | {DistanceMemo?.roadMiles || 0} mi{' '}
          </div>
        </div>

        {/* <div style={{
                    display: 'flex',
                    fontSize: isDesktop ? '13px' : '12px',
                    fontFamily: 'Inter Light',
                    letterSpacing: '0.5px',
                    color: 'Black',
                    textAlign: 'start',
                    marginBottom: '10px',
                    marginLeft: isDesktop ? '3%' : '4%',
                    flexWrap: 'wrap',
                    width: '60%'

                }}> Description about business Description about business Description about business Description about business </div> */}

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            marginBottom: '3px',
            marginLeft: '5px',
            marginTop: '15px',
          }}
        >
          <FastfoodIcon sx={{ color: '#181436', fontSize: '18px', marginRight: '5px' }} />
          <div
            style={{
              fontSize: '14px',
              fontFamily: 'Inter Bold', // Inter Medium Inter Bold  Inter Light Inter ExtraLight
              letterSpacing: '0.5px',
              marginLeft: '7px',
            }}
          >
            Combo bundle
          </div>

          <Chip
            label='Extra Saving'
            size='small'
            sx={{
              border: '1px solid #86c49a',
              background: '#dff5cf',
              color: '#06763f',
              height: '17px',
              fontSize: '11px',
              fontFamily: 'Inter Light',
              marginLeft: '10px',
              width: '90px',
            }}
          />
        </div>

        <div
          style={{
            display: 'flex',
            marginBottom: '10px',
            marginLeft: isDesktop ? '2.8%' : '3.8%',
          }}
        >
          {meal_offering?.main_dish !== 0 && meal_offering?.main_dish !== undefined && (
            <div
              style={{
                display: 'flex',
                fontSize: '13px',
                fontFamily: 'Inter Medium',
                letterSpacing: '0.5px',
                color: 'black',
              }}
            >
              {MealOffering_MainDish} {MealOffering_MainDish >= 2 ? 'Main dishes' : 'Main dish'} +
              &nbsp;
            </div>
          )}

          {meal_offering?.starter !== 0 && meal_offering?.starter !== undefined && (
            <div
              style={{
                display: 'flex',
                fontSize: '13px',
                fontFamily: 'Inter Medium',
                letterSpacing: '0.5px',
                color: 'black',
              }}
            >
              {MealOfferin_Starter} {MealOfferin_Starter >= 2 ? 'Starters' : 'Starter'} + &nbsp;
            </div>
          )}

          {meal_offering?.side !== 0 && meal_offering?.side !== undefined && (
            <div
              style={{
                display: 'flex',
                fontSize: '13px',
                fontFamily: 'Inter Medium',
                letterSpacing: '0.5px',
                color: 'black',
              }}
            >
              {MealOfferin_Side} {MealOfferin_Side >= 2 ? 'Sides' : 'Side'} + &nbsp;
            </div>
          )}

          {meal_offering?.power_side !== 0 && meal_offering?.power_side !== undefined && (
            <div
              style={{
                display: 'flex',
                fontSize: '13px',
                fontFamily: 'Inter Medium',
                letterSpacing: '0.5px',
                color: 'black',
              }}
            >
              {MealOfferin_PowerSide} {MealOfferin_PowerSide >= 2 ? 'Jumbo Sides' : 'Jumbo Side'} +
              &nbsp;
            </div>
          )}

          {meal_offering?.drink_dessert_treat !== 0 &&
            meal_offering?.drink_dessert_treat !== undefined && (
              <div
                style={{
                  display: 'flex',
                  fontSize: '13px',
                  fontFamily: 'Inter Medium',
                  letterSpacing: '0.5px',
                  color: 'black',
                }}
              >
                {MealOfferin_DrinkDessertTreat}{' '}
                {MealOfferin_DrinkDessertTreat >= 2
                  ? 'Drinks or Dessert treats'
                  : 'Drink or Dessert treat'}{' '}
                + &nbsp;
              </div>
            )}

          {meal_offering?.complementary !== 0 && meal_offering?.complementary !== undefined && (
            <div
              style={{
                display: 'flex',
                fontSize: '13px',
                fontFamily: 'Inter Medium',
                letterSpacing: '0.5px',
                color: 'black',
              }}
            >
              {' '}
              {MealOfferin_Complementary}&nbsp;{' '}
              {MealOfferin_Complementary >= 2 ? 'Complementaries' : 'Complementary'}&nbsp; 🔥
            </div>
          )}
        </div>
        {/* 
                <div style={{
                    display: 'flex',
                    alignContent: 'center',
                    fontSize: '13px',
                    fontFamily: 'Inter Bold', // Inter Medium Inter Bold  Inter Light Inter ExtraLight
                    letterSpacing: '0.5px',
                    marginLeft: '7px',
                    marginTop: '5px',
                    cursor: 'pointer'
                }} onClick={() => { console.log('-----Promo clicked') }}> <DiscountIcon
                        sx={{ color: '#181436', fontSize: '18px', marginRight: '10px' }}
                    />
                    Promo codes
                </div> */}

        <div
          style={{
            marginLeft: '5px',
            marginTop: '5px',
          }}
        >
          <DeliveryTimeSlotPicker />
        </div>
      </div>
    );
  }
}
export default Storetitle;
